import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import './index.scss'

function ReportsChart({data, intl}) {
  const {formatMessage} = intl;
  return(
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column'
          },
          title: {
            text: formatMessage({
              id: "app.first_most_visited",
              defaultMessage: "Most viewed movies"
            })
          },
          xAxis: {
            type: 'category',
            labels: {
              rotation: -45,
              style: {
                fontSize: '12px',
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: formatMessage({
                id: "app.view_count",
                defaultMessage: "View Count"
              })
            }
          },
          legend: {
            enabled: false
          },
          tooltip: {
            enabled: false
          },
          series: [{
            name: 'Population',
            data: data.map(item => ([ item.title, item.view_count ])),
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: '#FFFFFF',
              align: 'right',
              // format: '{point.y:.1f}', // one decimal
              y: 10, // 10 pixels down from the top
              style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
              }
            }
          }]
        }}
      />
    </div>
  )
}

export default injectIntl(ReportsChart);

